import { getOrderSaleItems, type Order } from '@src/domains/orders';
import type { SaleChange } from '@src/domains/sale-changes';
import { getSaleItems, type DetailedSaleItem, type Sale } from '@src/domains/sales';

export const getSaleChangeSummaryItems = (
  saleChange: SaleChange,
  sale?: Sale | null,
  order?: Order | null,
): DetailedSaleItem[] => {
  const parentItems = order ? getOrderSaleItems(order) : getSaleItems(sale);
  const itemFromParent = parentItems.find(({ id }) => id === saleChange.saleItemId);

  if (itemFromParent) {
    return [itemFromParent];
  }

  if (saleChange.saleItem) {
    return [saleChange.saleItem as DetailedSaleItem];
  }

  return [];
};
